document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".text-with-icons");

    if (!section) return; // Exit if the section is not found

    // Intersection Observer to detect when `.text-with-icons` is in view
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startNumberAnimation(); // Start animation when visible
                observer.disconnect(); // Stop observing after animation starts
            }
        });
    }, { threshold: 0.2 }); // Trigger when 20% of the section is visible

    observer.observe(section);

    function startNumberAnimation() {
        const numberElements = document.querySelectorAll('.text-with-icons__text-wrapper-content h6 strong');

        numberElements.forEach((element) => {
            const originalNumber = parseInt(element.textContent, 10); // Get the original number
            let duration = 1000; // Time in milliseconds before stopping at the original number
            let intervalTime = 50; // Speed of random number changes

            const randomizeNumber = () => {
                element.innerHTML = `${Math.floor(Math.random() * 10)}<br>`; // Preserve <br> tag
            };

            const interval = setInterval(randomizeNumber, intervalTime);

            // Stop after the duration and set back to the original number
            setTimeout(() => {
                clearInterval(interval);
                element.innerHTML = `${originalNumber}<br>`; // Restore original format
            }, duration);
        });
    }
});
